
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import checkmark from './../../assets/images/icon-utility-check-mark.svg';

import './AppBulletList.css';
import { Col, Container, Row } from '../../importCL';

interface IAppBulletListProps extends MappedComponentProperties {
    headline?: string,
    messages?: string[];
    hideOnDesktop?: boolean;
    hideOnMobile?: boolean;
}

export const AppBulletListEditConfig = {
    emptyLabel: 'App Bullet List',
    isEmpty: (props: PropsWithChildren<IAppBulletListProps>) => {
        return !props || !props.messages?.length;
    },
};

const AppBulletList = (props: PropsWithChildren<IAppBulletListProps>): JSX.Element => {
    return (
        <Container id='app-bullet-list' className={`AppBulletList 
            ${!props.isInEditor && props.hideOnDesktop ? 'AppBulletList--hideOnDesktop' : ''}
            ${!props.isInEditor && props.hideOnMobile ? 'AppBulletList--hideOnMobile' : ''}`} >
            <Row>
                <Col xs={12}>
                    {props.headline &&
                        <h3 className='AppBulletList__headline'>{transformHTMLParserLinks(props.headline)}</h3>
                    }
                    {props.messages?.map((message: string, i: number) => {
                        return (
                            message &&
                            <div key={i} className='AppBulletList__messageRow'>
                                <div className='AppBulletList__checkmarkCol'>
                                    <img className='AppBulletList__icon' loading='lazy' src={checkmark} alt='Checkmark' />
                                </div>
                                <div className='AppBulletList__textCol'>{transformHTMLParserLinks(message)}</div>
                            </div>
    
                        );
                    })}
                </Col>
            </Row>
        </Container>
    
    );
};

export default AppBulletList;
        